import {NewTenantParams, NewWixTenantParams, SignupType} from '../shared';
import {createWixBiHandler} from '.';
import {BIEvent} from './event-type';
import {Tenant} from '@wix/answers-api';
import { sanitizePII } from '@wix/bi-logger-sanitizer';

export type EventHandler = (event: BIEvent, data: any) => Promise<void>;

export type Logger = {
	logEvent: (event: BIEvent, data?: any) => void;
	logSignupSuccess: (event: BIEvent, tenant: Tenant, params: NewTenantParams | NewWixTenantParams, signupType: SignupType) => void;
};

export type withLogger = {
	logger: Logger;
};

export const ensurePasswordProtection = (data: any) => {
	Object.keys(data).forEach((key) => {
		if (key.toLowerCase().match(/\w*[pP]assword\w*/g)) {
			data[key] = '**************';
		}
	});

	return data;
};

export const ensureEIIProtection = (data: any) => {
	const url = /.*(wixanswers.com\/signup\/wix\/post)/g.exec(data.referral_url);
	data.referral_url = url && url[0] ? url[0] : data.referral_url;
	return data;
};

export const createConsoleHandler = (): EventHandler => {
	return (event: BIEvent) => {
		// tslint:disable-next-line:no-console
		// tslint:disable-next-line:max-line-length
		console.groupCollapsed(`[Logger] - ${BIEvent[event]}`);
		// tslint:disable-next-line:no-console
		console.log('Called with:');
		// tslint:disable-next-line:no-console
		console.log((event as any).data || event);
		console.groupEnd();
		return Promise.resolve();
	};
};

export const createLogger = (defaultData: any =  {}, handlers: EventHandler[]): Logger => {
	let maybePagelUrl = {};
	let maybeReferralUrl = {};
	let maybeReferralName = {};

	try {
		maybePagelUrl = document.URL ? {page_url: document.URL} : {};
		maybeReferralUrl = document.referrer ? {referral_url: document.referrer} : {};
		const capturedReferral = /referral=([^&]+)/.exec(window.location.href);
		maybeReferralName = capturedReferral && capturedReferral[1] ? {referral_name: capturedReferral[1]} : {};
	} catch (e) {
		// tslint:disable-next-line:no-console
		console.log(e);
	}

	const updatedDefaults = {
		...defaultData,
		...maybePagelUrl,
		...maybeReferralUrl,
		...maybeReferralName
	};

	const logEvent = (event: BIEvent, data: any = {}) => {

		// enforce PII compliance
		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				data[key] = sanitizePII(data[key]);
			}
		}

		handlers.forEach((handler) => {
			try {
				handler(event, {...ensureEIIProtection(updatedDefaults), ...data});
			} catch (e) {
				// tslint:disable-next-line:no-console
				console.error('error with log handler', e);
			}
		});
	};

	return {
		logEvent,
		logSignupSuccess: (event: BIEvent, tenant: Tenant, params: NewTenantParams | NewWixTenantParams, signupType: SignupType) => {
			logEvent(event, {tenant, signupParams: ensurePasswordProtection(params), signupType});
		}
	};
};

export const createLoggerWithAllHandlers = (defaultData: any = {}, isDebug?: boolean) => {
	const handlers = [createWixBiHandler()];
	if (isDebug) {
		handlers.push(createConsoleHandler());
	}
	return createLogger(defaultData, handlers);
};
